export default class RegionModel {
    id: number = 0
    name: string = ''
    url: string = ''
    cityId: number = 0
    countryId: number = 0
}